export const idlFactory = ({ IDL }) => {
  const GeneratedNFT = IDL.Record({
    'claim_timestamp' : IDL.Opt(IDL.Nat64),
    'claimed_by' : IDL.Opt(IDL.Principal),
    'sol_address' : IDL.Text,
    'evm_address' : IDL.Text,
    'token_id' : IDL.Nat64,
    'metadata' : IDL.Text,
    'rarity_score' : IDL.Float64,
    'icp_address' : IDL.Text,
    'layers' : IDL.Vec(IDL.Text),
    'claimed' : IDL.Bool,
    'image_hash' : IDL.Text,
    'qr_code_data' : IDL.Text,
    'rarity_tier' : IDL.Text,
  });
  const LayerConfig = IDL.Record({
    'weight' : IDL.Nat32,
    'file_name' : IDL.Text,
    'category' : IDL.Text,
    'rarity' : IDL.Float64,
  });
  const GenerationConfig = IDL.Record({
    'layer_configs' : IDL.Vec(LayerConfig),
    'collection_size' : IDL.Nat64,
  });
  return IDL.Service({
    'claim_nft_via_qr' : IDL.Func([IDL.Text], [GeneratedNFT], []),
    'get_all_nfts' : IDL.Func([], [IDL.Vec(GeneratedNFT)], []),
    'get_generated_nft' : IDL.Func([IDL.Nat64], [IDL.Opt(GeneratedNFT)], []),
    'get_generation_progress' : IDL.Func([], [IDL.Bool, IDL.Nat64], []),
    'get_qr_data' : IDL.Func([IDL.Nat64], [IDL.Opt(IDL.Text)], []),
    'get_unclaimed_nfts' : IDL.Func([], [IDL.Vec(GeneratedNFT)], []),
    'get_uploaded_layers' : IDL.Func([], [IDL.Vec(IDL.Text)], []),
    'inscribe_on_btc' : IDL.Func([IDL.Nat64], [IDL.Text], []),
    'pregenerate_collection' : IDL.Func([GenerationConfig], [IDL.Text], []),
    'upload_layers' : IDL.Func(
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Vec(IDL.Nat8)))],
        [IDL.Text],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
